import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { useToast } from '../context/ToastContext'
import { gamesApi } from '../api/games'

export default function HamburgerMenu() {
    const [open, setOpen] = React.useState(false)
    const { user, logout } = useAuth()
    const { addToast } = useToast()
    const navigate = useNavigate()

    function close() { setOpen(false) }

    async function handleNewGame() {
        close()
        try {
            const game = await gamesApi.createGame()
            navigate(`/game/${game.id}/setup`)
        } catch (err) {
            addToast(err.message, 'error')
        }
    }

    function handleLogout() {
        close()
        logout()
        navigate('/login')
    }

    const itemBase = "bg-transparent border-0 text-left px-4 py-2.5 font-karla text-[0.95rem] text-bankroll-text cursor-pointer w-full hover:bg-purple-50"

    return (
        <div className="relative ml-2">
            <button
                className="bg-transparent border-0 cursor-pointer px-2.5 py-1.5 leading-none"
                onClick={() => setOpen(o => !o)}
                aria-label="Menu"
                aria-expanded={open}
            >
                <span className="text-2xl text-bankroll-text">☰</span>
            </button>

            {open && (
                <>
                    <div className="fixed inset-0 z-[99]" onClick={close} />
                    <nav className="absolute right-0 top-[calc(100%+4px)] z-[100] bg-white border border-gray-200 rounded-lg shadow-lg min-w-[180px] py-2 flex flex-col">
                        <p className="px-4 pt-2 pb-1 font-bold text-bankroll-text text-[0.95rem] m-0">{user?.username}</p>
                        <hr className="border-0 border-t border-gray-200 my-1" />

                        <button className={itemBase} onClick={handleNewGame}>New Game</button>
                        <button className={itemBase} onClick={() => { close(); navigate('/lobby') }}>My Games</button>
                        <button className={itemBase} onClick={() => { close(); navigate('/lobby') }}>Invitations</button>
                        <button className={itemBase} onClick={() => { close(); navigate('/global-lookup') }}>Global Lookup</button>
                        <button className={itemBase} onClick={() => { close(); navigate('/top-ten') }}>Top Ten Games</button>

                        <hr className="border-0 border-t border-gray-200 my-1" />

                        {user?.is_admin && (
                            <button className={itemBase} onClick={() => { close(); navigate('/agreements/create') }}>Create Agreement</button>
                        )}
                        <button className={itemBase} onClick={() => { close(); navigate('/profile') }}>Profile</button>
                        <button className={`${itemBase} text-bankroll-danger hover:bg-red-50`} onClick={handleLogout}>Log Out</button>
                    </nav>
                </>
            )}
        </div>
    )
}
